import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createQueryClient } from "./app/queryClient";
import { createAppRouter } from "./app/router";
import { loadConfig } from "./config";
import { loadDiscovery } from "./servers/discovery";
import { initI18n } from "./i18n";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("index.html has no #root");
const root = createRoot(container);
initI18n();

// The discovery document is read before the first request, so every call already goes to the right region
// (WEB-SRV-BOOT-01); it never fails the start.
loadConfig()
  .then((c) => loadDiscovery(c.environment))
  .then(
    () => {
      const queryClient = createQueryClient();
      const router = createAppRouter();
      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </StrictMode>,
      );
    },
    (e: unknown) => {
      // Without its configuration the app cannot reach Keycloak or the API; say so instead of a blank page.
      root.render(<p role="alert">{e instanceof Error ? e.message : String(e)}</p>);
    },
  );
